module.exports = __webpack_public_path__ + "assets/return-arrow.9b22b171.svg";